import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Container, Grid } from "semantic-ui-react";
import { Routes, Route } from "react-router-dom";
import { setActiveNavID } from "../../app/appNavConfigSlice";

import LoyaltySideNav from "./LoyaltySideNav";
import ViewRedeemableSerial from "./my-loyalty/view-redeemable-serial/ViewRedeemableSerial";
import ClaimedHistory from "./my-loyalty/claimed-history/ClaimedHistory";

function Loyalty() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setActiveNavID("loyalty"));
  }, [dispatch]);

  return (
    <Container fluid>
      <Grid>
        <Grid.Column stretched width={2}>
          <LoyaltySideNav />
        </Grid.Column>

        <Grid.Column stretched width={14}>
          <Routes>
            <Route path="/" element={<ViewRedeemableSerial />} />
            <Route path="/claimed-history" element={<ClaimedHistory />} />
          </Routes>
        </Grid.Column>
      </Grid>
    </Container>
  );
}

export default Loyalty;
